import styled from "styled-components";
import { Container, Store, wrap, Wrapper } from 'AppReact';
import { InputError, Input } from 'molecules';
import { SectionLabel } from './../../../common/atoms';
import { DeleteButton, AddSection } from './../../../common/molecules';
import { FieldWrapper } from './../../../common/wrappers';
import device from "utils/device";
import { EmploymentSection } from './employmentInfo';
import { switchLabel } from './../../../utilities';

const template = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;

    @media ${device.tablet} {
        width: 594px;
    }
`
const WrappedInput = wrap(Input, FieldWrapper);
const WrappedInputError = wrap(InputError, FieldWrapper);

export const definition = {
    name: "EmploymentInformation",
    props: { isEditMode: Store, property: Store, employmentInformations: Store, selectedTabId: Store, language: Store },
    elements: [
        {
            wrapper: Wrapper(template),
            name: "Wrapper",
            elements: [
                {
                    componentSelect: switchLabel,
                    name: 'SectionTitle',
                    displayValue: ({ language }) => `${language?.employment_info || 'Employment Information'}`,
                    bindings: ({ selectedTabId }) => selectedTabId
                },
                {
                    component: EmploymentSection,
                    isListOf: 'employmentInformations',
                    name: 'employmentInfoList',
                    bindings: ({ language, isEditMode, selectedTabId, employmentInformations, employmentInformation }) => 
                    ({ language, isEditMode, employmentInformations, employmentInformation, onReview: selectedTabId == 'review' })
                },
            ]
        }

    ],
}
const EmploymentInformation = Container(definition);

export default EmploymentInformation;
